import { Outlet, useParams } from "react-router-dom";
import Loading from "../components/utils/Loading";
import { useEffect, useState } from "react";
import { properties } from '../utils/Properties_es';
import Logo from '../resources/images/bac_logo_white.svg';

const HomeLayout = () => {
  const [isLoading, setIsLoading] = useState(true); 
  const { id } = useParams();
  const [error, setError] = useState("");
  
  useEffect(() => {
    const validateTransaction = async () => {
      if (!id || id === "undefined") {
        setError(properties.home_error_no_id);
        setIsLoading(false);
        return;
      }else{
        setIsLoading(false);
      }
    };
    window.idTransaction = id;
    validateTransaction();
  }, [id]);

  if (isLoading) {
    return <Loading title={properties.general_loading} />;
  }

  if (error !== "") {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
        <div className="text-center p-5 border rounded shadow-sm bg-light">
          <i className="bi bi-exclamation-triangle-fill text-danger display-4 mb-3"></i>
          <h2 className="mb-3">{properties.general_attention}</h2>
          <p className="lead">{error}</p>
        </div>
      </div>
    );
  }

  // 5. Si no está cargando y NO hay error, renderizamos el layout normal
  document.title = properties.general_document_title;
  return (
    <>
      <header className="py-3 red-bac">
        <div>
          <a href="#!" className="logo d-flex align-items-start">
            <img src={Logo} alt="main_logo_bac" />
          </a>
        </div>
      </header>
      <main>
        <div className="container mt-5 pb-3 rounded-4 shadow px-4 px-lg-5">
          <Outlet />
        </div>
      </main>
    </>
  );
};
export default HomeLayout;
